module.exports = __webpack_public_path__ + "static/media/spectators-correct-answer-last-frame.36cde990.png";